import { BASE_SERVICE_URL } from '../../../lib/constants'
import type S3 from '../interface/s3Integration';

const create = async (s3: S3): Promise<void> => {
    delete s3.uid
    try {
        return await fetch(BASE_SERVICE_URL + `/s3`, {
            credentials: 'same-origin',
            method: 'POST',
            body: JSON.stringify(s3),
            headers: {
                "Content-Type": "application/json"
            }
        }).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        })

    } catch (error) {

    }
}



export default create